import { useMemo } from 'react';

import type { AddonCategory, SelectedAddon } from '../types/addons';
import { calculateAddonsPrice } from '../utils/addon';

export function usePriceCalculation(
  basePrice: number,
  quantity: number,
  addons: SelectedAddon[],
  addonCategories: AddonCategory[]
) {
  const totalPrice = useMemo(() => {
    const addonsTotal = calculateAddonsPrice(addons, addonCategories);

    return (basePrice + addonsTotal) * quantity;
  }, [basePrice, quantity, addons, addonCategories]);

  return totalPrice;
}
